import { accountsEndpoints, accountsPathDefinitions } from './Accounts';
import { appEndpoints, appPathDefinitions } from './App';
import { bankIdEndpoints, bankIdPathDefinitions } from './BankId';
import { bankSwapEndpoints, bankSwapPathDefinitions } from './BankSwap';
import { cardsEndpoints, cardsPathDefinitions } from './Cards';
import { customerEndpoints, customerPathDefinitions } from './Customer';
import {
  definedContributionsEndpoints,
  definedContributionsPathDefinitions,
} from './DefinedContributions';
import { eInvoiceEndpoints, eInvoicePathDefinitions } from './EInvoice';
import { epkFlexEndpoints, epkFlexPathDefinitions } from './EpkFlex';
import {
  externalProvidersEndpoints,
  externalProvidersPathDefinitions,
} from './ExternalProviders';
import { fundsEndpoints, fundsPathDefinitions } from './Funds';
import { huntingEndpoints, huntingPathDefinitions } from './Hunting';
import { insurancesEndpoints, insurancesPathDefinitions } from './Insurances';
import { loansEndpoints, loansPathDefinitions } from './Loans';
import {
  mortgageCalculatorPathDefinitions,
  mortgageCalculatorEndpoints,
} from './MortgageCalculator';
import { oddEndpoints, oddPathDefinitions } from './Odd';
import {
  paymentAgreementsEndpoints,
  paymentAgreementsPathDefinitions,
} from './PaymentAgreements';
import { paymentsEndpoints, paymentsPathDefinitions } from './Payments';
import { pensionEndpoints, pensionPathDefinitions } from './Pension';
import { pfmEndpoints, pfmPathDefinitions } from './Pfm';
import {
  preQualificationLettersEndpoints,
  preQualificationLettersPathDefinitions,
} from './PreQualificationLetters';
import {
  subscriptionsEndpoints,
  subscriptionsPathDefinitions,
} from './Subscriptions';
import {
  transactionsEndpoints,
  transactionsPathDefinitions,
} from './Transactions';

const PathDefinitions = {
  accounts: accountsPathDefinitions,
  app: appPathDefinitions,
  bankId: bankIdPathDefinitions,
  bankSwap: bankSwapPathDefinitions,
  cards: cardsPathDefinitions,
  customer: customerPathDefinitions,
  eInvoice: eInvoicePathDefinitions,
  funds: fundsPathDefinitions,
  externalProviders: externalProvidersPathDefinitions,
  hunting: huntingPathDefinitions,
  insurances: insurancesPathDefinitions,
  loans: loansPathDefinitions,
  paymentAgreements: paymentAgreementsPathDefinitions,
  payments: paymentsPathDefinitions,
  pfm: pfmPathDefinitions,
  preQualificationLetters: preQualificationLettersPathDefinitions,
  subscriptions: subscriptionsPathDefinitions,
  transactions: transactionsPathDefinitions,
  epkFlex: epkFlexPathDefinitions,
  definedContributions: definedContributionsPathDefinitions,
  mortgageCalculator: mortgageCalculatorPathDefinitions,
  pension: pensionPathDefinitions,
  odd: oddPathDefinitions,
};

const Endpoints = {
  accounts: accountsEndpoints,
  app: appEndpoints,
  bankId: bankIdEndpoints,
  bankSwap: bankSwapEndpoints,
  cards: cardsEndpoints,
  customer: customerEndpoints,
  externalProviders: externalProvidersEndpoints,
  funds: fundsEndpoints,
  hunting: huntingEndpoints,
  insurances: insurancesEndpoints,
  loans: loansEndpoints,
  paymentAgreements: paymentAgreementsEndpoints,
  payments: paymentsEndpoints,
  pfm: pfmEndpoints,
  preQualificationLetters: preQualificationLettersEndpoints,
  subscriptions: subscriptionsEndpoints,
  transactions: transactionsEndpoints,
  epkFlex: epkFlexEndpoints,
  definedContributions: definedContributionsEndpoints,
  mortgageCalculator: mortgageCalculatorEndpoints,
  pension: pensionEndpoints,
  eInvoice: eInvoiceEndpoints,
  odd: oddEndpoints,
};

export { Endpoints, PathDefinitions };
